import React from "react";
import PropTypes from 'prop-types';
import DynamicTable from "../../widgets/dynamicTable/DynamicTable";
import HelperMetiers360 from "../../../services/HelpersMetiers360";
import { Alert } from "react-bootstrap";
import { useStoreState } from "easy-peasy";
import { Link } from "react-router-dom";

const VideoConversionsComponent =(props) => {
    const { conversions } = props;
    const videosSlugs = useStoreState(actions => actions.actionSlugs.actionSlugsDispatcher('videos'));

    const fromVideoMediaLabel = (conversion) => {
        return conversion.fromVideoMedia ? <>{conversion.fromVideoMedia.localName} {conversion.fromVideoMedia.isPublished ? <i className="far fa-eye" /> : ""}</> : '-';
    }

    const videoMediasGeneratedLabel = (conversion) => {
        return <ul>{conversion.videoMediasGenerated?.map(media => <li key={media.uniqueId}>{media.localName} {media.isPublished ? <i className="far fa-eye" /> : ""}</li>)}</ul>;
    }

    const sortVideoConversionStatus = (a, b) => {
        const getPriority = (video) => {
            if (video.ongoing) return 2;
            if (video.done) return 3;
            return 1;
        };

        return getPriority(a) - getPriority(b);
    };

    const sortType = [
        {
            value: 'videoFor', label: 'XP',
            test: HelperMetiers360.isArrayContainsValue(conversions, "videoFor"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.videoFor, b.videoFor),
            display: (conversion) => <Link to={videosSlugs.readOne.replace(':uniqueId', conversion.video?.uniqueId)}>
                {conversion.videoFor}
            </Link>,
            flatDisplay: (conversion) => conversion.videoFor,
        },
        {
            value: 'createdDate', label: "Date de création",
            test: HelperMetiers360.isArrayContainsValue(conversions, "createdAt"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.createdAt, b.createdAt),
            display: (conversion) => conversion.createdAt ?
                HelperMetiers360.getdisplayDateType(conversion.createdAt, 'day')
                : '-'
        },
        {
            value: 'updatedAt', label: "Date de modification",
            test: HelperMetiers360.isArrayContainsValue(conversions, "updatedAt"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.updatedAt, b.updatedAt),
            display: (conversion) => conversion.updatedAt ?
                HelperMetiers360.getdisplayDateType(conversion.updatedAt, 'hour')
                : '-'
        },
        {
            value: 'done', label: "Faite ?",
            test: HelperMetiers360.isArrayContainsValue(conversions, "done"),
            method: (a, b) => sortVideoConversionStatus(a, b),
            display: (conversion) => conversion.done ? 
                <i className='fas fa-check' /> 
                : <>{conversion.ongoing ? 
                    <i className='fas fa-rocket' /> 
                    : <i className="far fa-clock" />}</>,
            flatDisplay: (conversion) => conversion.done ? "Oui" : "Non",
        },
        {
            value: 'fromVideoMedia', label: "Conversion depuis",
            test: HelperMetiers360.isArrayContainsValue(conversions, "fromVideoMedia"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.fromVideoMedia?.localName, b.fromVideoMedia?.localName),
            display: (conversion) => fromVideoMediaLabel(conversion),
            flatDisplay: (conversion) => conversion?.fromVideoMedia?.localName ?? "",
        },
        {
            value: 'videoMediasGenerated', label: "Fichiers générés",
            test: HelperMetiers360.isArrayContainsValue(conversions, "videoMediasGenerated"),
            display: (conversion) => videoMediasGeneratedLabel(conversion),
            flatDisplay: (conversion) => conversion.videoMediasGenerated?.map(media => media.localName)?.join(',') ?? "",
        }
    ];

    return (
        conversions?.length > 0 ?
            <DynamicTable
                contentTable={conversions}
                contentSort={sortType}
                index='uniqueId'
                valueInitSort="updatedAt"
            />
            : <Alert variant="warning">Pas de conversions enregistrées pour cette expérience</Alert>
    );
}

VideoConversionsComponent.propTypes = {
    conversions: PropTypes.array.isRequired
}

export default VideoConversionsComponent;